
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import TrinkgeldBestellungLogic from "@/logic/bestellung/trinkgeld_bestellung_logic"

@Component({ components: { NichtGueltig, FilialeHeader } })
export default class TrinkgeldBestellung extends mixins(Calculator) {
  logic: TrinkgeldBestellungLogic = null

  mounted() {
    this.logic = new TrinkgeldBestellungLogic()
    this.logic.init()
  }

  weiter() {
    this.logic.weiter()
  }
}
